// Fonts an admin can pick for the Wall of Fame (WTF > Background Settings). The choice is saved
// as `fontFamily` in the WTF settings and applied to the Wall of Fame section only, for every
// role; the rest of the app keeps its own font. All are Google Fonts.
export const WTF_FONTS = [
  { name: "Baloo 2", group: "Playful" },
  { name: "Comic Neue", group: "Playful" },
  { name: "Fredoka", group: "Playful" },
  { name: "Bubblegum Sans", group: "Playful" },
  { name: "Chewy", group: "Playful" },
  { name: "Luckiest Guy", group: "Playful" },
  { name: "Bangers", group: "Playful" },
  { name: "Lobster", group: "Playful" },
  { name: "Righteous", group: "Playful" },
  { name: "Patrick Hand", group: "Handwriting" },
  { name: "Kalam", group: "Handwriting" },
  { name: "Indie Flower", group: "Handwriting" },
  { name: "Caveat", group: "Handwriting" },
  { name: "Architects Daughter", group: "Handwriting" },
  { name: "Gloria Hallelujah", group: "Handwriting" },
  { name: "Shadows Into Light", group: "Handwriting" },
  { name: "Dancing Script", group: "Handwriting" },
  { name: "Nunito", group: "Clean" },
  { name: "Quicksand", group: "Clean" },
  { name: "Poppins", group: "Clean" },
  { name: "Roboto", group: "Clean" },
  { name: "Open Sans", group: "Clean" },
  { name: "Lato", group: "Clean" },
  { name: "Montserrat", group: "Clean" },
  { name: "Raleway", group: "Clean" },
  { name: "Ubuntu", group: "Clean" },
  { name: "Merriweather", group: "Classic" },
  { name: "Lora", group: "Classic" },
  { name: "Playfair Display", group: "Classic" },
  { name: "Libre Baskerville", group: "Classic" },
];

export const WTF_FONT_GROUPS = ["Playful", "Handwriting", "Clean", "Classic"];

const FALLBACK = {
  Playful: "cursive",
  Handwriting: "cursive",
  Clean: "sans-serif",
  Classic: "serif",
};

// CSS font-family value for a font name, e.g. `"Kalam", cursive`.
export const wtfFontStack = (name) => {
  if (!name) return undefined;
  const font = WTF_FONTS.find((f) => f.name === name);
  return `"${name}", ${FALLBACK[font?.group] || "sans-serif"}`;
};

// Adds the Google Fonts stylesheet for a font once, so a preview can show it straight away.
export const loadWtfFont = (name) => {
  if (!name || typeof document === "undefined") return;
  const id = `wtf-font-${name.replace(/\s+/g, "-").toLowerCase()}`;
  if (document.getElementById(id)) return;
  const link = document.createElement("link");
  link.id = id;
  link.rel = "stylesheet";
  link.href = `https://fonts.googleapis.com/css2?family=${name.replace(
    /\s+/g,
    "+"
  )}:wght@400;600;700&display=swap`;
  document.head.appendChild(link);
};
